<div class="notification-title display-flex align-items-center no-wrap" mat-dialog-title>
  {{ 'Custom notifications' }}
</div>

<mat-dialog-content>
  <!-- <div class="warning" *ngIf="orderError">
    <div class="message">
      <div class="icon">
        <app-icon
          [iconWidth]="20"
          [iconHeight]="20"
          [svg]="EIcon.WARNING"
          [iconColor]="EColorPalette.cWhite"></app-icon>
      </div>
      <div>
        <span class="strong">Remind On</span>
        cannot be set earlier than
        <span class="strong">Notify On</span>
      </div>
    </div>
  </div> -->
  <div class="notification-modal">
    <div [formGroup]="form" class="display-flex flex-column grid-gap-16">
      <div class="flex-1">
        <app-radio-button-dropdown
          class="flex-grow-1"
          [containerCss]="'w-100'"
          [items]="notifyOptions"
          label="Notify on"
          formControlName="notifyOn"
          [allowClear]="false"
          [allowSearch]="false"
          [autoSortList]="false"
          [showValidationError]="false"
          [labelRequired]="false"
          [attrPlaceholder]="'On due date'"
          attrAppendTo="body"></app-radio-button-dropdown>
      </div>

      <!-- <div class="flex-1">
        <app-radio-button-dropdown
          class="flex-grow-1"
          [containerCss]="'w-100'"
          [items]="remindOptions"
          label="Remind on"
          formControlName="remindOn"
          [attrDisable]="notifyAssignee.value === false"
          [allowClear]="false"
          [allowSearch]="false"
          [autoSortList]="false"
          [showValidationError]="false"
          [labelRequired]="false"
          [attrPlaceholder]="'On due date'"
          attrAppendTo="body"></app-radio-button-dropdown>
      </div> -->

      <div class="flex-1">
        <div class="display-flex grid-gap-16">
          <div class="flex-50 remind-field">
            <app-radio-button-dropdown
              class="flex-grow-1"
              [containerCss]="'w-100'"
              [items]="remindThenOptions"
              label="Then remind"
              formControlName="thenRemindOn"
              [allowClear]="false"
              [allowSearch]="false"
              [autoSortList]="false"
              [showValidationError]="false"
              [labelRequired]="false"
              [attrPlaceholder]="'On due date'"
              attrAppendTo="body"></app-radio-button-dropdown>
          </div>
          <div class="flex-50 remind-field">
            <app-radio-button-dropdown
              class="flex-grow-1"
              [containerCss]="'w-100'"
              [items]="untilOptions"
              label="Until"
              formControlName="until"
              [allowClear]="false"
              [allowSearch]="false"
              [autoSortList]="false"
              [showValidationError]="false"
              [labelRequired]="false"
              [attrDisable]="thenRemindOn.value === DontNotifyId"
              [attrPlaceholder]="'On due date'"
              attrAppendTo="body"></app-radio-button-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div class="display-flex justify-content-space-between w-100">
    <button mat-stroked-button color="primary" (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()">Done</button>
  </div>
</mat-dialog-actions>
